import { PropsWithChildren, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useSearchParams } from "react-router-dom";
import { selectIsLoggedIn, userActions } from "../../store/user";
import api from "../../network/api";
import { Route } from "../../routes/Route";
import { StorageKey } from "../../store/storage";

const StatisticsAutoLoginGate = ({ children }: PropsWithChildren) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [attempted, setAttempted] = useState<boolean>(isLoggedIn);
  const [failed, setFailed] = useState<boolean>(false);

  useEffect(() => {
    if (isLoggedIn || attempted) return;

    const email = searchParams.get("email");
    const password = searchParams.get("password");

    if (!email || !password) {
      setFailed(true);
      setAttempted(true);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const token = await api.login(email, password);
        if (cancelled) return;
        if (token) {
          localStorage.setItem(StorageKey.NAME, email);
          dispatch(userActions.loginSuccess({ token }));
          window.history.replaceState(null, "", `/${Route.Statistics}`);
        } else {
          setFailed(true);
        }
      } catch {
        if (!cancelled) setFailed(true);
      } finally {
        if (!cancelled) setAttempted(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isLoggedIn, attempted, dispatch, searchParams]);

  if (!isLoggedIn && !attempted) return null;
  if (!isLoggedIn && failed) {
    return <Navigate to={`/${Route.Login}`} replace />;
  }
  // @ts-ignore
  return <>{children}</>;
};

export default StatisticsAutoLoginGate;
